import RandingStyle4 from "../../randing/RandingStyle4";

function Randing092({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle4
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/092/20250210_1.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/092/20250210_2.gif`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/092/20250210_3.jpg`}
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/092/20250210_4.jpg`}
      img5Path={`${process.env.REACT_APP_CDN_BASE}/images/092/20250210_5.jpg`}
      img6Path={`${process.env.REACT_APP_CDN_BASE}/images/003/01_241101_06.jpg`}
      benefitInfoPosition="top"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/003/01_241101_05.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori2.jpg`}
    />
  );
}

export default Randing092;
